import { CommonModule, } from '@angular/common';
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, } from '@angular/core';
import { I18nModule, ProductScope } from '@spartacus/core';
import { CurrentProductService, SpinnerModule } from '@spartacus/storefront';
import { GenDocumentService } from 'src/app/generac/services/document.service';
import { ActivatedRoute } from '@angular/router';
import { GenLoadingEnum } from 'src/app/generac/enums/loading.enum';
import { GenDocumentsResponse, GenDocument } from 'src/app/generac/models/document.model';
import { Subscription, of } from 'rxjs';
import { catchError, finalize, switchMap, tap } from 'rxjs/operators';
import { RouterModule } from '@angular/router';
import { Observable, combineLatest } from 'rxjs';

@Component({
  selector: 'gen-download-link',
  templateUrl: './download-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, I18nModule, RouterModule, SpinnerModule]
})
export class GenDownloadLinkComponent implements OnDestroy, OnInit {
  private subscriptions = new Subscription();
  
  loading = GenLoadingEnum.Idle;
  GenLoadingEnum = GenLoadingEnum;

  searchBy = 'model';
  spSearchCode = '';
  specSheetLinkToggle = false;
  document?: GenDocument;
  allDocuments: GenDocument[] = [];

  readonly product$: Observable<any | null> = this.currentProductService.getProduct([ProductScope.DETAILS]);

  constructor(
    protected currentProductService: CurrentProductService,
    protected documentService: GenDocumentService,
    protected activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
        combineLatest([
          this.activatedRoute.params.pipe(
            tap(params => (this.spSearchCode = params?.productCode || ''))
          ),
          this.product$,
        ])
        .pipe(
          switchMap(([_, product]) => {
            this.specSheetLinkToggle = !!product.specSheetLinkToggle;
            return this.loadDocuments();
          })
        )
        .subscribe()
    );
  }

  scrollToDocuments(): void {
    const target = document.querySelector<HTMLElement>('.Tabs');
    if (target) {
      window.scrollTo({
        top: target.offsetTop - 65,
        behavior: 'smooth',
      });
    }
  }

  private loadDocuments(): Observable<GenDocumentsResponse | void> {
     this.loading = GenLoadingEnum.Loading;
     const currentPage = 0;
     const pageSize = 100;

     return this.documentService.getDocuments(this.searchBy, this.spSearchCode, currentPage, pageSize).pipe(
           tap((res: GenDocumentsResponse) => {
            this.allDocuments = res.documents || [];
            this.document = this.allDocuments.find(
              doc => doc.fileType === 'Spec Sheet' && doc.language === 'EN'
            );
            this.cdr.markForCheck();
           }),
           catchError(() => {
              this.loading = GenLoadingEnum.Failed;
              return of();
           }),
           finalize(() => this.loading = GenLoadingEnum.Loaded)
     )
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}